<template>
  <div id="mb-test" class="mb-test" @click="cancelCheck()">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <!-- <div v-if="gameState" class="curtain" @click="cancelCheck()"></div> -->
    <div class="mb-test-question-container" :style="style">
      <div
        class="question-field"
        style="background: transparent; box-shadow: none"
        v-if="!startGameConfig.withoutAnswers"
      >
        <div></div>
        <div class="mb-test-answers">
          <div
            class="mb-test-answer"
            :style="{ width: ans.width + 'px', height: ans.height + 'px' }"
            v-for="(ans, ansIndex) in answers"
            :key="'question-list-' + ansIndex"
          >
            <span>{{ ans.text }}</span>
          </div>
        </div>
      </div>
      <mb-test-question
        @checkTest="checkGameStatus()"
        :question="it"
        :game-status="gameState"
        :border-active-status="borderActiveStatus"
        :border-active="startGameConfig.answersBorder"
        :audio-data="startGameConfig.audio"
        :text-status="startGameConfig.showAnswerTextInQuestion"
        v-for="(it, itIndex) in items"
        :key="'question-list-' + itIndex"
      >
        <img slot="question-img" v-if="it.image" :src="giveMeImagePlease(it.image.src)" :style="it.image.cssStyle" />
      </mb-test-question>
    </div>
  </div>
</template>
<script>
import MbTestQuestion from './MbTestQuestion/MbTestQuestion';
import defaultMixin from '../../mixins/defaultMixin';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'mb-test',
  components: { MbTestQuestion },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      gameState: false,
      borderActiveStatus: false,
      style: {
        fontSize: '50px',
        width: '900px',
      },
      answers: [
        { text: 'tak', width: 150, height: 100 },
        { text: 'nie', width: 150, height: 100 },
      ],
      items: [],
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    setState(questionIndex, ansIndex) {
      this.$set(this.items[questionIndex].answers, ansIndex, 'correct');
    },
    setValue(items, id, it) {
      this.$set(items, id, it);
    },
    createAnswersTable() {
      let array = [];
      this.answers.forEach((it) => {
        let arrayIt = it;
        arrayIt.state = 'unset';
        array.push(arrayIt);
      });
      return array;
    },
    init() {
      if (this.startGameConfig.answers) this.answers = _.cloneDeep(this.startGameConfig.answers);
      let questionArray = this.createAnswersTable();
      let tmp = _.cloneDeep(this.startGameConfig.items);
      if (this.startGameConfig.shuffle) tmp = this.shuffle(tmp);
      this.items = _.cloneDeep(tmp);
      if (this.startGameConfig.style) this.style = _.cloneDeep(this.startGameConfig.style);
      // console.table(this.startGameConfig.answers);

      // console.table(this.answers);
      this.items.forEach((el, index) => {
        if (!el.answers) {
          el.answers = _.cloneDeep(questionArray);
          if (this.startGameConfig.questionPos) el.pos = this.startGameConfig.questionPos[index];

          for (let x = 0; x < el.answers.length; x++) {
            if (el.correct == x) {
              el.answers[x].correct = true;
            }
            el.block = false;
          }
        }
      });
    },
    // console.log(this.items);
    cancelCheck() {
      if (!this.gameState) {
        // this.gameState = false;
        // this.$store.commit('CHANGE_CHECK_SWITCH', false);
        if (this.gameCheckSwitch) this.$store.commit('CHANGE_CHECK_SWITCH', false);

        this.borderActiveStatus = false;
      }
    },
    checkGameStatus() {
      if (this.borderActiveStatus) {
        this.gameState = true;
        this.items.forEach((el) => {
          el.answers.forEach((elAns) => {
            // console.log(elAns.state + ' : ' + elAns.correct);
            if (elAns.state == 'set') {
              elAns.block = true;
              if (!elAns.correct) {
                this.gameState = false;
                elAns.block = false;
                elAns.state = 'unset';
              }
            } else if (elAns.state == 'unset') {
              elAns.block = false;
              if (elAns.correct) this.gameState = false;
            }
          });
          for (let x = 0; x < el.answers.length; x++) {
            if (el.answers[x].block == true) {
              el.block = true;
            }
          }
        });
        setTimeout(() => {
          if (this.gameState) this.$store.dispatch('checkGame');
        }, 100);
      } else {
        this.gameState = true;
        this.items.forEach((el) => {
          el.answers.forEach((elAns) => {
            // console.log(elAns.state + ' : ' + elAns.correct);
            if (elAns.state == 'set') {
              if (!elAns.correct) this.gameState = false;
            } else if (elAns.state == 'unset') {
              if (elAns.correct) this.gameState = false;
            }
          });
        });
        setTimeout(() => {
          if (this.gameState) this.$store.dispatch('checkGame');
        }, 100);
      }
    },
    // newcheckGameStatus() {
    //   this.gameState = true;
    //   this.items.forEach((el) => {
    //     el.answers.forEach((elAns) => {
    //       // console.log(elAns.state + ' : ' + elAns.correct);
    //       if (elAns.state == 'set') {
    //         if (!elAns.correct) this.gameState = false;
    //       } else if (elAns.state == 'unset') {
    //         if (elAns.correct) this.gameState = false;
    //       }
    //     });
    //   });
    //   // setTimeout(() => {
    //   //   if (this.gameState) this.$store.dispatch('checkGame');
    //   // }, 100);
    // },
    checkGameAction() {
      this.borderActiveStatus = true;
      this.checkGameStatus();

      return this.gameState;
    },
    resetGameAction() {
      this.gameState = false;
      this.style = {
        fontSize: '50px',
        width: '900px',
      };
      this.answers = [
        { text: 'tak', width: 150, height: 100 },
        { text: 'nie', width: 150, height: 100 },
      ];
      this.items = [];
      setTimeout(() => {
        this.init();
      }, 1);
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {},
  computed: {
    gameCheckSwitch() {
      return this.$store.getters.gameCheckSwitch;
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.curtain
  position: absolute
  top: 0
  width: 1920px
  height: 1080px
  left: 0
  z-index: 2
.mb-test
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  display: flex
  align-items: center
  flex-direction: column
  justify-content: center
  .mb-test-question-container
    z-index: 1
    font-size: 24px
    .question-field
      text-align: left
      margin: 20px 10px
      padding: 0px 10px
      background: white
      border-radius: 10px
      display: flex
      align-items: center
      justify-content: space-between
      box-shadow: 0 0 2px 2px rgba(0,0,0,0.3)
  .mb-test-answers
    display: flex
    align-items: center
    justify-content: center
    // border-radius: 10px
    .mb-test-answer
      border-radius: 10px
      margin: 10px
      width: 100px
      height: 100px

      display: flex
      align-items: center
      cursor: pointer
      justify-content: center
      box-shadow: 0 0 2px 1px rgba(0,0,0,0.3)

.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
</style>
